import { render, staticRenderFns } from "./ArchiveManage.vue?vue&type=template&id=2ef1b74e&"
import script from "./ArchiveManage.vue?vue&type=script&lang=js&"
export * from "./ArchiveManage.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveManage.vue?vue&type=style&index=0&id=2ef1b74e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports